/**
 * This file provides the controller for the horizontal scrolling on the Home page.
 */

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

let scrollTween = null

export function getHomeHorizontalTween() {
  return scrollTween
}

export function initRegisterButtonScroll() {
  const registerButton = document.querySelectorAll('a[href="#register"]')
  const scrollContainer = document.querySelector('.scroll-container')
  const track = scrollContainer?.querySelector('.horizontal-track')
  const registerSection = document.querySelector('section.register, #register')

  if (!registerButton) return

  registerButton.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault()

      if (window.innerWidth < 768) {
        // Mobile: scroll to the register section with a small top breathing room.
        const mobileRegisterOffset = 8
        const registerTop = registerSection
          ? registerSection.getBoundingClientRect().top + window.scrollY
          : document.body.scrollHeight

        const targetY = Math.max(0, registerTop - mobileRegisterOffset)

        window.scrollTo({
          top: targetY,
          behavior: 'smooth'
        })
      } else if (track) {
        // Desktop: scroll to end of horizontal scroll
        if (scrollTween && scrollTween.scrollTrigger) {
          const st = scrollTween.scrollTrigger
          const endScroll = st.end // px value where the horizontal scroll ends
          gsap.to(window, {
            scrollTo: { y: endScroll },
            duration: 1,
            ease: 'power2.inOut'
          })
        } else {
          // fallback: scroll to end manually
          const maxScroll = track.scrollWidth - window.innerWidth
          gsap.to(track, {
            x: -maxScroll,
            duration: 1,
            ease: 'power2.inOut'
          })
        }
      }
    })
  })
}

const initializeScroll = () => {
  const scrollContainer = document.querySelector('.scroll-container')
  const track = scrollContainer?.querySelector('.horizontal-track')
  if (!scrollContainer || !track) return

  const panels = track.querySelectorAll('.panel')
  const totalPanels = panels.length
  if (totalPanels < 2) return

  const panelOffsets = Array.from(panels).map(panel => panel.offsetLeft)
  const totalWidth = track.scrollWidth
  const maxScroll = totalWidth - window.innerWidth

  scrollTween = gsap.to(track, {
    x: () => `-${maxScroll}`,
    ease: "none",
    scrollTrigger: {
      trigger: scrollContainer,
      start: "top top",
      end: () => `+=${maxScroll}`,
      scrub: true,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      snap: {
        snapTo: (progress) => {
          const scroll = progress * maxScroll
          let closest = panelOffsets.reduce((prev, curr) =>
            Math.abs(curr - scroll) < Math.abs(prev - scroll) ? curr : prev
          )
          return closest / maxScroll
        },
        duration: { min: 0.3, max: 0.7 },
        ease: "power1.inOut"
      },
      // markers: true
    }
  })
}

const killScroll = () => {
  if (scrollTween) {
    scrollTween.scrollTrigger?.kill()
    scrollTween.kill()
    scrollTween = null
  }
}

export function init() {
  const handleResize = () => {
    killScroll()

    if (window.innerWidth >= 768) {
      initializeScroll()
    }
  }

  window.addEventListener('resize', handleResize)
  handleResize()
}